import { Component, EventEmitter, Output } from '@angular/core';
import { Common } from '../../shared/common';

@Component({
  selector: 'voters-validate-popup',
  templateUrl: './voters-validate-popup.component.html',
  styleUrls: ['./voters-validate-popup.component.less', '../../shared/common.less']
})
export class VotersValidatePopupComponent {
  @Output() isClosed = new EventEmitter<boolean>();

  onDismiss(confirm: boolean) {
    this.isClosed.emit(confirm);
  }

  constructor(public common: Common) { }

}
